export const V2_ROLES = Object.freeze({
  user: "user",
  admin: "admin",
  developer: "developer",
});

const ADMIN_ROLES = new Set([V2_ROLES.admin, V2_ROLES.developer]);

export function normalizeV2Role(role) {
  const normalized = String(role || "").trim().toLowerCase();
  return Object.values(V2_ROLES).includes(normalized) ? normalized : V2_ROLES.user;
}

export function hasAdminAccess(role) {
  return ADMIN_ROLES.has(normalizeV2Role(role));
}

export function isDeveloper(role) {
  return normalizeV2Role(role) === V2_ROLES.developer;
}
